import { WalletAddressType } from "./Billing";

export enum BillingConfigNames {
  scanConfig = "scanConfig",
}

type BaseBillingConfig = {
  id: string;

  createdAt: string | null;
  updatedAt: string | null;
  deletedAt: string | null;
  createdBy: string | null;
  updatedBy: string | null;
};

export type BillingConfig = BaseBillingConfig & {
  name: BillingConfigNames.scanConfig;
  data: BillingConfigScanConfig;
};
// | {
//     name: BillingConfigNames.twoFactorAuthConfig;
//     data: BillingConfigIpWhiteList;
//   }

export type BillingConfigScanConfig = {
  [WalletAddressType.USDT]: {
    scanUrl: string;
  };
};
